<template>
  <div class="grid grid-cols-3 gap-4">
    <div
      v-for="(theme, index) in themes"
      class="relative rounded-md p-2 text-center border-2 border-neutral-300 dark:border-neutral-600 cursor-pointer"
      :class="{
        [theme.styleClass]: true,
        'font-bold': theme.bold,
        '!border-nami-comi-blue': selectedThemeIndex === index,
      }"
      :style="{
        fontFamily: theme.fontFamily,
        fontSize: getFontRatio(theme.fontFamily),
        lineHeight: '1.5rem',
      }"
      @click="selectedThemeIndex = index"
    >
      <div>Aa</div>
      <div>{{ theme.name }}</div>
      <TransitionFade>
        <IconAsterisk
          v-if="theme.modified"
          :size="12"
          stroke-width="3"
          class="absolute top-2 right-2"
        />
      </TransitionFade>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getNovelThemes } from "~/src/novel/themes";
import type { NovelStyleTemplate } from "~/src/novel/style";
import { IconAsterisk } from "@tabler/icons-vue";
import { FontSheet } from "~/src/novel/style";

const { themes = getNovelThemes() } = defineProps<{
  themes: (NovelStyleTemplate & { modified?: boolean })[];
}>();

const selectedThemeIndex = defineModel({ required: true, default: 0 });
const getFontRatio = (font: string) => {
  const trueFont = font.split(",")[0].replaceAll('"', "");
  return FontSheet[trueFont]?.baseFontRatio
    ? FontSheet[trueFont]?.baseFontRatio + "em"
    : undefined;
};
</script>

<style scoped lang="postcss"></style>
